
import React from 'react'
import { connect } from "react-redux"
import ReactDOM from 'react-dom'
import { fetchTherapyAreas } from "../../actions/index"
import { adminCreateTherapyArea, adminDeleteTherapyArea, adminCreateTherapyCategory } from "../../actions/admin"
import { setTitle } from "../../actions/index"

//import styles
import './styles/AdminTherapyAreas.scss';

import closeImage from '../../images/icons/close_black.svg';

import AdminTherapyArea from './AdminTherapyArea'

@connect(store => {
  return {
    therapy_areas: store.therapy_areas,
    User: store.User.User,
    app: store.app,
    practice_types: store.practice_types,
    therapy_categories: store.therapy_categories
  };
})
class AdminTherapyAreas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openNewItem: false,
      newItem: {
        name: "",
        description: "",
        adminNote: ""
      },
      professionSelection: ""
    };
    this.props.dispatch(setTitle("Admin: Therapy Areas"));
    this.props.dispatch(fetchTherapyAreas());
    this.handleNewItemChange = this.handleNewItemChange.bind(this);
    this.handleNewItemSubmit = this.handleNewItemSubmit.bind(this);
    this.toggleNewItem = this.toggleNewItem.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleProfessionChange = this.handleProfessionChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      professionSelection: this.props.practice_types[0]._id
    })
  }

  handleDelete(id) {
    if (confirm("Really delete this Therapy Area?")) {
      this.props.dispatch(adminDeleteTherapyArea(id));
    }
  }

  handleNewItemChange(e, field) {
    let newItem = this.state.newItem;
    newItem[field] = e.target.value;
    this.setState({ newItem: newItem });
  }

  handleProfessionChange(e){
    this.setState({ professionSelection: e.target.value });
  }

  handleNewItemSubmit(e) {
    e.preventDefault();
    if (this.state.newItem.name !== "") {
      this.props.dispatch(adminCreateTherapyArea(this.state.newItem));
    }
    this.setState({
      newItem: {
        name: "",
        description: "",
        adminNote: ""
      }
    });
    this.toggleNewItem();
  }

  toggleNewItem() {
    this.setState({ openNewItem: !this.state.openNewItem });

    // slide page down too
    let page = ReactDOM.findDOMNode(this.refs.page);
    let addNewItem = ReactDOM.findDOMNode(this.refs.addNewItem);
    let transform = this.state.openNewItem ? -200 : addNewItem.offsetHeight;
    page.style.transition = "0.34s transform ease-out";
    page.style.transform = `translateY(${transform}px)`;
  }

  render() {
    return (
      <main className="main adminTherapyAreas">
        <div
          ref="addNewItem"
          className={
            this.state.openNewItem
              ? "addItem--wrapper open"
              : "addItem--wrapper"
          }
        >
          <form onSubmit={this.handleNewItemSubmit}>
            <input
              className="md-input md-title"
              onChange={e => this.handleNewItemChange(e, "name")}
              value={this.state.newItem.name}
              type="text"
              placeholder="Therapy area title"
              contentEditable="true"
            />

            <input 
              className="md-input md-title" 
              placeholder="Admin note"
              onChange={e => this.handleNewItemChange(e, "adminNote")}
              value={this.state.newItem.adminNote}
              type="text" 
              contentEditable="true"
            />

            <textarea
              className="md-input multiple"
              value={this.state.newItem.description}
              placeholder="Therapy area description"
              onChange={e => this.handleNewItemChange(e, "description")}
            />
            <p>
              <br />
              <button
                className="md-button md-raised md-primary"
                onClick={this.handleNewItemSubmit}
              >
                Create
              </button>
            </p>
          </form>
          <a
            href="#"
            onClick={this.toggleNewItem}
            className="top-draw-handle md-button-fab"
          >
            <img
              alt="close"
              className={
                "open-close " + (this.state.openNewItem ? "close" : "")
              }
              src={closeImage}
            />
          </a>
        </div>
        <div ref="page">
          <div className="select my1 p1">
            Profession:
            <select
              value={this.state.professionSelection}
              onChange={e => this.handleProfessionChange(e)}
            >
              {this.props.practice_types.map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
              <option value="111">Uncategorized</option>
            </select>
          </div>
          <div>
            <ul className="md-list wide">
              {Object.values(this.props.therapy_areas)
                .filter(area => {
                  if(this.state.professionSelection === "111"){
                    return area.categories.length == 0
                  } else {
                    let allowed = false;
                    area.categories.forEach(cat => {
                      var findCatIndex = Object.values(this.props.therapy_categories).find(ct => ct.id === cat);
                      if (findCatIndex != undefined) {
                        if (findCatIndex.practice_type == this.state.professionSelection) {
                          allowed = true;
                          return;
                        }
                      }
                    });
                    return allowed;
                  }
                })
                .map(area => (
                  <AdminTherapyArea
                    handleDelete={this.handleDelete}
                    area={area}
                    key={area._id}
                    clickDelete={this.handleDelete}
                  ></AdminTherapyArea>
                ))}
            </ul>
          </div>
        </div>
      </main>
    );
  }
}

export default AdminTherapyAreas;



// WEBPACK FOOTER //
// ./src/components/admin/AdminTherapyAreas.jsx